import useProfile from '../../../hooks/useProfile';
import { caseListContainerClasses } from '../../../components/common/caseListClasses';
import SuperAdminPageWrapper from '../components/SuperAdminPageWrapper';
import ProfileForm from '../../../components/ProfileForm';
import ProfileFormActionButton from '../../../components/ProfileFormActionButton';

const SuperProfile = () => {
  const { formik } = useProfile();
  const handleSave = async () => {
    await formik.submitForm();
  }

  return (
    <SuperAdminPageWrapper>
      <div className={`container ${caseListContainerClasses}`}>
        <div className="listing">
          <div className="p-0!">
            <ProfileForm formik={formik} resetPasswordPath='/super/forgot-password' />
          </div>
          <ProfileFormActionButton
            cancelPath="/super/companies"
            onSave={handleSave}
            disabled={formik.isSubmitting}
          />
        </div>
      </div>
    </SuperAdminPageWrapper>

  )
}

export default SuperProfile;
